import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from 'shared/ui/error-boundary';
import { ToggleTranslateButton } from 'shared/ui/toggle-translate-button';
import { CloseIcon, EmailIcon } from 'shared/ui/icons';
import ImageBackground from 'shared/assets/images/bg-image-login.png';
import ImageLogo from 'shared/assets/images/logo_sembuh_ai.png';
import useSendResetLink from '../hooks/useSendResetLink';

const CardWrapper = ({ children }) => (
  <div className="w-1/4 flex flex-wrap p-8 rounded-2xl bg-white justify-center items-center text-center">
    {children}
  </div>
);

const Spinner = () => (
  <div className="animate-spin rounded-full h-5 w-5 border-t-2 mx-3 my-0.5 border-white border-solid m-auto" />
);

const SendResetLinkPage = () => {
  const { t } = useTranslation('common');
  const {
    loading,
    linkReset,
    formData,
    errors,
    handleChange,
    handleSendEmail,
    redirectLogin,
    config,
  } = useSendResetLink();

  return (
    <ErrorBoundary>
      <main
        className="w-full content-center h-screen flex flex-col items-center md:bg-slate-100"
        style={{
          backgroundImage: `url(${ImageBackground})`,
          backgroundSize: '100% 100%',
        }}
      >
        <div className="flex items-center justify-center h-full w-full mt-[-24px]">
          {linkReset ? (
            <CardWrapper>
              <div className="w-full flex justify-end">
                <button
                  type="button"
                  onClick={redirectLogin}
                  className="cursor-pointer"
                >
                  <CloseIcon width="16" />
                </button>
              </div>
              <div className="w-full flex justify-center mb-6">
                <EmailIcon width="32" height="32" />
              </div>
              <div className="w-full">
                <span className="font-semibold text-2xl">
                  {t('email_sent')}
                </span>
              </div>
              <div className="w-full">
                <span className="text-base font-normal text-slate-500">
                  {t('check_email_for_reset_link')}
                </span>
              </div>
            </CardWrapper>
          ) : (
            <CardWrapper>
              <button
                type="button"
                onClick={redirectLogin}
                className="w-full contents cursor-pointer"
              >
                <img
                  src={ImageLogo}
                  alt="logo_sembuh_ai"
                  className="sl-w-auto"
                />
              </button>
              <div className="w-full mt-5">
                <span className="font-semibold text-2xl">
                  {t(config.titleKey)}
                </span>
              </div>
              <div className="w-full">
                <span className="text-base font-normal text-slate-500">
                  {t('enter_email_to_access_verification_link')}
                </span>
              </div>
              {errors?.error && (
                <div className="w-full rounded-lg py-3 px-4 bg-red-100 border-2 border-red-300 mt-6 text-[#B42318] font-medium text-sm text-start">
                  {errors?.error}
                </div>
              )}
              <div className="w-full my-5">
                <div>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      placeholder="Email"
                      onChange={handleChange}
                      value={formData?.email}
                      className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
                    />
                    {errors?.email && (
                      <div className="w-full justify-start items-start flex">
                        <span className="text-red-500 text-sm">
                          {errors?.email}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-col justify-center text-center mt-1 gap-4">
                <button
                  type="button"
                  onClick={handleSendEmail}
                  disabled={!!loading}
                  className="flex w-full bg-blue-500 justify-center rounded-md bg-con-brand px-3 py-2 text-medium font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                  {loading ? <Spinner /> : t(config.buttonKey)}
                </button>
                <div className="flex justify-between items-center gap-1">
                  <p>{t('select_language')}</p>
                  <ToggleTranslateButton />
                </div>
              </div>
            </CardWrapper>
          )}
        </div>
      </main>
    </ErrorBoundary>
  );
};

export default SendResetLinkPage;
